import { http } from "config/http";

export const getRolesData = async () => {
    try {
        const res: any = await http.get(`get_all_roles?client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getRoleById = async (id: string) => {
    try {
        const res: any = await http.get(`get_role_by_id?role_id=${id}&client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const addRoleData = async (body: { created_by: string, role_name: string, description: string }) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.post(`add_role`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const roleActiveDeactive = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.post(`role_active_deactive`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const roleUpdate = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.put(`update_role`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const activeRoles = async () => {
    try {
        const res: any = await http.get(`get_active_roles?client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}


